import React from 'react'
import { compose } from 'recompose'
import { makeStyles } from '@material-ui/core/styles'
import { injectIntl } from 'react-intl'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { Container, Grid } from '@material-ui/core'
import LineChart from './LineChart'
import BarChart from './BarChart'
import Button from '@material-ui/core/Button'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx'

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<Typography
			data-testid="survey-response-tabs-inner"
			component='div'
			role='tabpanel'
			hidden={value !== index}
			id={`scrollable-force-tabpanel-${index}`}
			aria-labelledby={`scrollable-force-tab-${index}`}
			{...other}>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	)
}

function a11yProps(index) {
	return {
		id: `scrollable-force-tab-${index}`,
		'aria-controls': `scrollable-force-tabpanel-${index}`
	}
}

const COLOR_MYRESULTS = '#057AFE'
const COLOR_ALLRESULTS = '#010E23'
const MAX_CHARS = 300

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: '100%',
		backgroundColor: '#11121C',
		color: 'white',
		fontSize: '1.2em',
		paddingTop: '16px',
		
		[theme.breakpoints.down('sm')]: {
            margin: '0 -16px',
			width: 'calc(100% + 32px)',
        },
	},
	gridInner: {
		padding: '0',
		margin: '0 -24px',
		width: 'calc(100% + 24px)',
		[theme.breakpoints.down('sm')]: {
            margin: '-12px -40px 0 -40px',
			width: '100vw',
        },
	},
	tabPanel: {
		width: '100%',
		padding: '0',
		overflow: 'auto',
		[theme.breakpoints.down('sm')]: {
			margin: '0 -16px',
			width: 'calc(100% - 32px)',			
        },
	},
	chartGraph: {
		flex: 0.7,
		[theme.breakpoints.down('sm')]: {
			flex: 1,
        },
	},
	chartText: {
		flex: 0.3,
		paddingTop: '95px',
		[theme.breakpoints.down('sm')]: {
			flex: 1,
			padding: '40px 24px 0 24px',
        },
	},
	label: {
		color: '#9C9DA1',
		fontSize: '17px'
	},
	buttonRoot: {
		color: 'white',
		border: '1px solid white',
		padding: '3px 16px',
		'& p': {
			color: 'white',
			fontSize: '1rem',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			maxWidth: '200px',
			padding: '0 5px'
		},
		minWidth: '0px'
	},
	circle: {
		width: 10,
		height: 10,
		borderRadius: 5
	},
	myResultsCircle: {
		width: 10,
		height: 10,
		borderRadius: 5,
		backgroundColor: COLOR_MYRESULTS,
		display: 'inline-block'
	},
	allResultsCircle: {
		backgroundColor: COLOR_ALLRESULTS,
		display: 'inline-block'
	}
}))

const SurveyResponseTabs = ({ schema, intl }) => {
	const classes = useStyles()
	const [ value, setValue ] = React.useState(0)
	const [ showAbout, setShowAbout ] = React.useState(true)
	const [ subShowAbout, setSubShowAbout ] = React.useState(false)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	return (
		<div className={classes.root}>
			<Grid container direction='column' alignItems='center'>
				<Tabs
					data-testid="survey-response-tabs-header"
					style= {{ maxWidth: '100%' }}
					value={value}
					onChange={handleChange}
					variant='scrollable'
					scrollButtons='on'
					aria-label='scrollable force tabs'>
					{schema &&
						schema.map((item, index) => (
							<Tab className={classes.label} label={item.scoringGroupName} {...a11yProps(index)} />
						))}
				</Tabs>
				{schema &&
					schema.map((item, index) => (
						<TabPanel data-testid="survey-response-tabpanel" value={value} index={index} className={classes.tabPanel}>
							<Grid container className={classes.gridInner}>
								<Grid item className={clsx(classes.chartGraph, `chartGraph`)}>
									{item.coordinates.length < 5 && (
										<BarChart data-testid="survey-response-barchart" data={item.coordinates} min={item.minScore} max={item.maxScore} />
									)}
									{item.coordinates.length >= 5 && (
										<LineChart data-testid="survey-response-linechart" data={item.coordinates} min={item.minScore} max={item.maxScore} />
									)}
								</Grid>
								<Grid item className={classes.chartText}>
									<Grid container>
										<Grid item style={{ width: '100%' }}>
											<Grid container direction='column'>
												<Grid item>
													<Typography
														data-testid="survey-response-chart-label"
														variant='body1' style={{ padding: '0 0 5px 0' }}>{intl.formatMessage({ id: 'app.chart.chartKeyLabel' })}</Typography>
												</Grid>
												<Grid item>
													<Grid style={{ display: 'inline-block', width: '15px', padding: '0 5px 0 0' }}>
														<Grid
															data-testid="survey-response-circle"
															className={classes.myResultsCircle}>
														</Grid>
													</Grid>
													<Grid style={{ display: 'inline-block' }}>
														<Typography
															data-testid="survey-response-results-label"
															variant='body1'
															style={{ color: COLOR_MYRESULTS }}>
															{intl.formatMessage({ id: 'app.chart.yourResultsLabel' }).toUpperCase()}
														</Typography>
													</Grid>
												</Grid>
												{/* <Grid item>
													<Grid style={{ display: 'inline-block', width: '15px' }}>
														<Box className={[ classes.circle, classes.allResultsCircle ]} />
													</Grid>
													<Grid style={{ display: 'inline-block' }}>
														<Typography
															variant='body1'
															style={{ letterSpacing: '2px', color: COLOR_ALLRESULTS }}>
															ALL RESULTS
														</Typography>
													</Grid>
												</Grid> */}
											</Grid>
										</Grid>
										{item.scoringGroupDescription &&
										item.scoringGroupDescription.length > 0 && (
											<div>
												<Grid item style={{ paddingTop: '5rem' }}>
													<Button
														data-testid="button-show-about"
														className={classes.buttonRoot}
														onClick={() => setShowAbout(!showAbout)}>
														<Grid container justify='space-around' alignItems='flex-start' style={{ flexWrap: 'nowrap'}}>
															<Grid item style={{ alignSelf: 'center' }}>
																<Typography style={{ fontSize: '17px' }}>
																	{intl.formatMessage({ id: 'app.chart.aboutText' })}
																</Typography>
															</Grid>
															<Grid item style={{ alignSelf: 'center' }}>
																{showAbout && (
																	<KeyboardArrowUp style={{ color: 'white', fontSize: '22px' }} />
																)}
																{!showAbout && (
																	<KeyboardArrowDown style={{ color: 'white', fontSize: '22px' }} />
																)}
															</Grid>
														</Grid>
													</Button>
													{showAbout && (
														<Grid style={{ padding: '8px 0px' }}>
															{item.scoringGroupDescription && (
																<div>
																	{!subShowAbout && (
																		<Typography
																			data-testid="scoring-group-desc-hidden"
																			style={{ fontSize: '17px', paddingBottom: '8px' }}>
																			{item.scoringGroupDescription.substring( 0, MAX_CHARS )}
																		</Typography>
																	)}
																	{subShowAbout && (
																		<Typography
																			data-testid="scoring-group-desc-show"
																			style={{ fontSize: '17px', paddingBottom: '8px' }}>
																			{item.scoringGroupDescription}
																		</Typography>
																	)}
																	{item.scoringGroupDescription.length >
																		MAX_CHARS && (
																		<Button
																			data-testid="button-show-scoring-group"
																			className={classes.buttonRoot}
																			onClick={() =>
																				setSubShowAbout(!subShowAbout)}>
																			{!subShowAbout && (
																				<Grid container justify='space-around' alignItems='flex-start'>
																					<Grid item>
																						<Grid container>
																							<Grid item style={{ alignSelf: 'center' }}>
																								<Typography style={{ fontSize: '17px' }}>
																									{intl.formatMessage( { id: 'app.chart.moreText' } )}
																								</Typography>
																							</Grid>
																						</Grid>
																					</Grid>
																				</Grid>
																			)}
																			{subShowAbout && (
																				<Grid container justify='space-around' alignItems='flex-start'>
																					<Grid item style={{ alignSelf: 'center' }}>
																						<Typography
																							data-testid="show-about-text"
																							style={{ fontSize: '17px' }}>
																							{intl.formatMessage( { id: 'app.chart.lessText' } )}
																						</Typography>
																					</Grid>
																				</Grid>
																			)}
																		</Button>
																	)}
																</div>
															)}
															{!item.scoringGroupDescription && (
																<Typography data-testid="scoring-group-no-text" style={{ fontSize: '17px' }}>
																	{intl.formatMessage({ id: 'app.chart.noContentText' })}
																</Typography>
															)}
														</Grid>
													)}
												</Grid>
											</div>
										)}
									</Grid>
								</Grid>
							</Grid>
						</TabPanel>
					))}
			</Grid>
		</div>
	)
}

const enhance = compose(injectIntl)

export default enhance(SurveyResponseTabs)
